import { BroadcastDeliveryItemWithId } from 'models/broadcast.model';
import { Text } from '@epam/uui';
import { dateWithTimeToString } from 'hooks/helpers/date-time-helper';
import { StatusIndicatorDot } from '../../../common';
import { FlexRow } from '@epam/promo';

const columns = [
  {
    key: 'chatId',
    caption: 'Chat id',
    width: 200,
    isSortable: true,
    render: (item: BroadcastDeliveryItemWithId) => <Text>{item.chatId}</Text>,
  },
  {
    key: 'status',
    caption: 'Status',
    width: 100,
    isSortable: true,
    render: (item: BroadcastDeliveryItemWithId) => (
      <FlexRow>
        <StatusIndicatorDot size="8" status={item.status} />
        <Text>{item.status}</Text>
      </FlexRow>
    ),
  },
  {
    key: 'errorCode',
    caption: 'Error code',
    width: 100,
    isSortable: true,
    render: (item: BroadcastDeliveryItemWithId) => (
      <Text>{item.errorCode}</Text>
    ),
  },
  {
    key: 'errorMessage',
    caption: 'Error message',
    width: 200,
    render: (item: BroadcastDeliveryItemWithId) => (
      <Text>{item.errorMessage}</Text>
    ),
  },
  {
    key: 'sentAt',
    caption: 'Sent at',
    width: 200,
    render: (item: BroadcastDeliveryItemWithId) => (
      <Text>{dateWithTimeToString(item.sentAt)}</Text>
    ),
  },
  {
    key: 'deliveredAt',
    caption: 'Delivered at',
    width: 200,
    render: (item: BroadcastDeliveryItemWithId) => (
      <Text>{dateWithTimeToString(item.deliveredAt)}</Text>
    ),
  },
  {
    key: 'lastAttemptAt',
    caption: 'Last attempt at',
    width: 200,
    render: (item: BroadcastDeliveryItemWithId) => (
      <Text>{dateWithTimeToString(item.lastAttemptAt)}</Text>
    ),
  },
  {
    key: 'attempts',
    caption: 'Attempts',
    width: 100,
    render: (item: BroadcastDeliveryItemWithId) => <Text>{item.attempts}</Text>,
  },
  {
    key: 'createdAt',
    caption: 'Created at',
    width: 200,
    render: (item: BroadcastDeliveryItemWithId) => (
      <Text>{dateWithTimeToString(item.createdAt)}</Text>
    ),
  },
  {
    key: 'updatedAt',
    caption: 'Updated at',
    width: 200,
    render: (item: BroadcastDeliveryItemWithId) => (
      <Text>{dateWithTimeToString(item.updatedAt)}</Text>
    ),
  },
];

export default columns;
